import {
  easeInOutSine,
  smoothstep,
  clamp,
  w, h,
  frame,
  frameN,
  setFrameN,
  getCanvasSize,
  setupCommon,
  drawCommon,
  make,
} from '../js/common.js';
import p5 from 'p5';
import kdTree from './kdTree.min.js';

export function setup() {
	setupCommon();
	textSize(w(0.015));
}

function boundingBox(points) {
	let xmin = Math.min(...points.map(p => p[0])) - 0.01;
	let ymin = Math.min(...points.map(p => p[1])) - 0.01;

	let xmax = Math.max(...points.map(p => p[0])) + 0.01;
	let ymax = Math.max(...points.map(p => p[1])) + 0.01;

	return [xmin, ymin, xmax, ymax];
}

const distanceFn = function(a, b) {
	return Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2);
}

const veinStep = 0.0015;

const nodes = [[0.5, 0.925]];
const food = [];
const childlessNodes = new Set([0]);
const edges = new Map();
const edgeGraph = new Map();
let largest = 1;
export function draw() {
	drawCommon();

	background(5);
	translate(w(0.4), h(-0.1));
	rotate(QUARTER_PI);
	noFill();
	stroke(0, 0, 95, 0.05);
	strokeWeight(w(0.001));
	rect(w(-0.5), h(-0.5), w(1), h(1));
	rect(w(-0.25), h(-0.25), w(0.5), h(0.5));
	rect(w(0.25), h(0.85), w(0.75), h(0.75));
	rect(w(0.75), h(0.35), w(0.75), h(0.75));
	resetMatrix();


	const oldNodesTree = new kdTree.kdTree(
		nodes.map(([x, y], idx) => ({ x, y, idx })),
		distanceFn,
		['x', 'y']
	);

	const enoughFood = food.length > 50 || nodes.length > 6000;
	if (!enoughFood) {
		const bb = boundingBox(nodes);
		const dy = bb[3] - bb[1];

		const vr = 3.0;
		const vs = 0.8;
		const [vx, vy] = nodes[0];
		const vscale = 0.031 + dy * 0.14;

		const vbot = sqrt(vs * vs * vr * vr) / vs;
		const vtop = -vbot;
		for (let i = 0; i < 10; i++) {

			const y = Math.random() * 0.95 * (vbot - vtop) - vbot + 0.05;
			const bound = vs * (sqrt(sq(vs * vr) - sq(vs * y)) - 0.5) * vscale;
			const foodX = Math.random() * 2 * bound - bound + vx;
			const foodY = y * vscale + (vy - vbot * vscale);

			if (foodX > 0 && foodX < 1 && foodY > 0 && foodY < 1)
				if (oldNodesTree.nearest({ x: foodX, y: foodY }, 1, 0.000025).length == 0)
					food.push([foodX, foodY]);
		}
	}

	const nodeInfluences = {};
	food.forEach(([foodX, foodY], foodIdx) => {
		const nodeIdx = oldNodesTree.nearest({ x: foodX, y: foodY }, 1)[0][0].idx;
		const foodVec = createVector(food[foodIdx][0], food[foodIdx][1]);
		const nodeVec = createVector(nodes[nodeIdx][0], nodes[nodeIdx][1]);
		const direction = p5.Vector.sub(foodVec, nodeVec).normalize();

		if (nodeInfluences[nodeIdx])
			nodeInfluences[nodeIdx].add(direction);
		else
			nodeInfluences[nodeIdx] = direction;
	});
	Object.keys(nodeInfluences).forEach(k => {
		nodeInfluences[k].normalize()
	});

	const newNodes = [];
	Object.keys(nodeInfluences).forEach(k => {
		const node = nodes[k];
		const influence = nodeInfluences[k]
		const newNode = [node[0] + influence.x * veinStep, node[1] + influence.y * veinStep];
		const newIdx = nodes.push(newNode) - 1;
		newNodes.push(newNode);

		const parentIdx = Number(k);
		childlessNodes.add(newIdx);
		const parentWasChildless = childlessNodes.delete(parentIdx);
		edgeGraph.set(newIdx, parentIdx);
		edges.set(`${newIdx}-${parentIdx}`, 1);

		if (!parentWasChildless) {
			let currentIdx = parentIdx;
			while (currentIdx !== 0) {
				const currentParentIdx = edgeGraph.get(currentIdx);
				const edgeKey = `${currentIdx}-${currentParentIdx}`
				const weight = edges.get(edgeKey);
				edges.set(edgeKey, weight + 1);
				currentIdx = currentParentIdx;
				largest = Math.max(largest, weight);
			}
		}
	});

	// remove food if vein is in neighborhood
	newNodes.forEach(([nodeX, nodeY]) => {
		food.forEach(([foodX, foodY], idx) => {
			const d = dist(foodX, foodY, nodeX, nodeY);
			if (d < 0.025)
				food.splice(idx, 1);
		});
	});

	edges.forEach((weight, key) => {
		const [a, b] = key.split('-').map(Number);
		const [x1, y1] = nodes[a];
		const n = sqrt(weight / largest);
		strokeWeight(w(0.0015));
		stroke(noise(frameCount * 0.01, y1, n * 5) * 100 + 150, 60 - 30 * n, 60 + 20 * n, 0.25);
		ellipse(w(x1), h(y1), w(n * 0.1));
	});
}
